import { useAppSelector } from "@/store";
import { useGetProfileQuery } from "@/store/generatedApi";
import { ReactElement, ReactNode, useEffect, useState } from "react";

export const AuthorizeView = (props: {
  policy: string;
  authorized: ReactNode | ReactElement;
  notAuthorized: ReactNode | ReactElement;
}) => {
  const selectedAccountSlug = useAppSelector(
    (state) => state.selectedAccount.slug
  );
  const selectedOrganizationId = useAppSelector(
    (state) => state.selectedOrganization.id
  );
  const { data: user } = useGetProfileQuery({
    organizationId: selectedOrganizationId,
    accountSlug: selectedAccountSlug,
  });

  const [allow, setAllow] = useState<boolean | undefined>();
  useEffect(() => {
    if (user) {
      setAllow(Reflect.get(user?.permissions ?? {}, props.policy));
    }
  }, [user]);

  return <> {allow ? props.authorized : props.notAuthorized}</>;
};
